import { Suspense, lazy } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";

import Home from './components/pages/Home';
import Login from './components/pages/Login';
import App from "./App";
import NotFound from "./components/pages/errors/NotFound";
import AccessDenied from "./components/pages/errors/AccessDenied";
import InternalError from "./components/pages/errors/InternalError";
import Logout from "./components/pages/Logout";

import NetworkError from "./components/pages/errors/NetworkError";

import LegalPersonPageList from "./components/pages/person/legal_person/LegalPersonPageList";
import IndividualPageList from "./components/pages/person/individual/IndividualPageList";
import IndividualPageForm from "./components/pages/person/individual/IndividualPageForm";
import IndividualPageEdit from "./components/pages/person/individual/IndividualPageEdit";


import LegalPersonPageForm from "./components/pages/person/legal_person/LegalPersonPageForm";

import MaintenanceFormPage from "./components/pages/maintenance/MaintenanceForm";

import ScoreAgrolendModal from "./components/pages/referrals/ScoreAgrolendModal";
import Loading from "./components/ions/Loading";
import BiroListModal from "./components/pages/referrals/BiroListModal";
import BiroVariablesModal from "./components/pages/referrals/BiroVariablesModal";
import BiroDocumentModal from "./components/pages/referrals/BiroDocumentModal";
import ReferralDetailModal from "./components/pages/referrals/ReferralDetailModal";

import ReferralPartnerAnalysisListPage from './components/pages/referrals/PartnerAnalysisList';
import CreditLimitAnalysisForm from "./components/pages/referrals/CreditLimitAnalysisForm";
import ReferralPartnerAnalyzedListPage from './components/pages/referrals/PartnerAnalyzedList';
import RequireAuth from "./services/Auth/RequireAuth";

import FarmerOrderListPage from './components/pages/referrals/FarmerOrderList';

import BatchAnalysisListPage from "./components/pages/referrals/BatchAnalysisList";
import BatchAnalysisFormPage from "./components/pages/referrals/BatchAnalysisForm";
import BatchAnalysisView from "./components/pages/referrals/BatchAnalysisView";

import CommercialPage from "./components/pages/commercial/CommercialPage";
import CommercialFormPage from "./components/pages/commercial/CommercialFormPage";

import FeatureFlagReferral from './components/pages/configuration/FeatureFlagReferralListPage';
import FeatureFlagReferralView from "./components/pages/configuration/FeatureFlagReferralViewPage";
import ReasonPageList from "./components/pages/referrals/ReasonPageList";
import ReasonFormModal from "./components/pages/referrals/ReasonFormModal";
import ReferralConfiguration from "./components/pages/referrals/ReferralConfiguration";
import LoanOrderAnalysisForm from "./components/pages/referrals/LoanOrderAnalysisForm";
import FarmerOrderUnlinkedListPage from "./components/pages/referrals/FarmerOrderUnlinkedList";
import LinkUpReferralWithLoanOrderFormPage from "./components/pages/referrals/LinkUpReferralWithLoanOrderForm";
import ReferralLoanOrderRejectedListPage from "./components/pages/referrals/ReferralLoanOrderRejectedList";
import LoanOrderAnalysisListPage from "./components/pages/referrals/LoanOrderAnalysisList";

import NotificationPageList from "./components/pages/communication/NotificationPageList";
import NotificationCalendarPage from "./components/pages/communication/NotificationCalendar";

import BatchNotificationForm from "./components/pages/communication/BatchNotifcationForm";
import TemplateViewPage from "./components/pages/communication/TemplateViewPage";
import TemplatesPageList from "./components/pages/communication/TemplatesPageList";
import CommunicationConfiguration from "./components/pages/communication/CommunicationConfiguration";

import UserPageList from "./components/pages/user/UserPageList";
import UserPageView from "./components/pages/user/UserPageView";

import ContractDisbursementList from "./components/pages/financial/ContractDisbursementList";
import LoanFormPage from "./components/pages/loan/LoanForm";
import FarmerDataViewPage from "./components/pages/farmer/FarmerDataView";
import FarmerPageList from "./components/pages/loan/FarmerPageList";
import SelectProfilesModal from "./components/pages/person/shared/SelectProfilesModal";
import LegalPersonPageEdit from "./components/pages/person/legal_person/LegalPersonPageEdit";
import BlockListPage from "./components/pages/referrals/BlockListPage";
import BlockListInputForm from "./components/pages/referrals/BlockListInputForm";
import BlockListChanged from "./components/pages/referrals/BlockListChanged";

import ReportTypePageList from "./components/pages/data-provider/ReportTypePageList";
import ReportTypePageForm from "./components/pages/data-provider/ReportTypePageForm";
import ReportTypePageView from "./components/pages/data-provider/ReportTypePageView";
import BatchReportPageForm from "./components/pages/data-provider/BatchReportPageForm";
import BatchReportPageList from "./components/pages/data-provider/BatchReportPageList";
import BatchReportPageView from "./components/pages/data-provider/BatchReportPageView";
import AnnualProviderReportPageList from "./components/pages/data-provider/AnnualProviderReportPageList";
import SoftwarePortfolioPageList from "./components/pages/ti/SoftwarePortfolioPageList";
import SicorReportPageList from "./components/pages/sicor/ReportPageList";
import SicorDocumentPageList from "./components/pages/sicor/DocumentPageList";
import SicorDocumentPageView from "./components/pages/sicor/DocumentPageView";

import RecommendationEngineRulesList from "./components/pages/recommendation-engine/RecommendationEnginePageList";
import RecommendationEnginePageForm from "./components/pages/recommendation-engine/RecommendationEnginePageForm";
import RecommendationEnginePageView from "./components/pages/recommendation-engine/RecommendationEnginePageView";
import RecommendationEngineRecommendationsList from "./components/pages/recommendation-engine/RecommendationEngineRecommendationsList";
import RecommendationEngineRecommendationView from "./components/pages/recommendation-engine/RecommendationEngineRecommendationView";
import RecommendationEngineParecerView from "./components/pages/recommendation-engine/RecommendationEngineParecerView";
import ProviderDocumentsGrid from "./components/pages/recommendation-engine/ProviderDocumentsGrid";

import OperationsPage from "./components/pages/operations/OperationsPage";
import OperationReceivablesAssignmentFormPage from "./components/pages/operations/OperationReceivablesAssignmentFormPage";
import OperationLoanFormPage from "./components/pages/operations/OperationLoanFormPage";
import ReceivablesAssignmentPage from "./components/pages/operations/ReceivablesAssignmentPage";

// import ReportPageList from "./components/pages/data-provider/ReportPageList";
import StructuredOperationPage from "./components/pages/operations/StructuredOperationPage";
import AcknowledgementDebtPage from "./components/pages/operations/AcknowledgementDebtPage";

import OperationPageList from "./components/pages/structuring/OperationPageList";
import OperationPageForm from "./components/pages/structuring/OperationPageForm";
import OperationPageView from "./components/pages/structuring/OperationPageView";

import BillerListBills from "./components/pages/financial/BillerListBills";
import BillerCreateBill from "./components/pages/financial/BillerCreateBill";
import BillerBatchCreateBill from "./components/pages/financial/BillerBatchCreateBill";
import LiquidationsList from "./components/pages/financial/LiquidationsList";
import DimensaLoteList from "./components/pages/financial/DimensaLoteList";


const Cities = lazy(() => import('./components/pages/geo-location/Cities'));
const Provinces = lazy(() => import('./components/pages/geo-location/Provinces'));


const AppRoutes = () => {

    const ADMIN = 'ADMIN';
    const OPERATOR = 'OPERATOR';
    const LEGAL = 'LEGAL';
    const CREDIT_ANALYST = 'CREDIT_ANALYST';
    const CREDIT_MANAGER = 'CREDIT_MANAGER';
    const FINANCIAL = 'FINANCIAL';
    const CONTRACT_OPERATIONS_ANALYST = 'CONTRACT_OPERATIONS_ANALYST';
    const INDIVIDUAL_PERSON = 'INDIVIDUAL_PERSON';
    const COLLECTION_ANALYST = 'COLLECTION_ANALYST';
    const BLOCKLIST = 'BLOCKLIST';
    // não usado por enquanto: const COMMERCIAL_MANAGER = 'COMMERCIAL_MANAGER';
    const MLP_ANALYST = 'MLP_ANALYST';


    return (
        <HashRouter>
            <Routes>
                <Route path="/" element={<App />} errorElement={<InternalError />}>
                    <Route path="home" element={<RequireAuth roles={[ADMIN, OPERATOR, LEGAL, CREDIT_ANALYST, CREDIT_MANAGER]}><Home /></RequireAuth>} />
                    <Route path="person/partners/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <LegalPersonPageList />
                        </RequireAuth>
                    }>
                        <Route
                            path="profiles/:personId"
                            element={<SelectProfilesModal />}
                        />
                    </Route>

                    <Route path="person/partners/form" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <LegalPersonPageForm />
                        </RequireAuth>
                    } />

                    <Route path="person/partners/edit/:personId" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <LegalPersonPageEdit />
                        </RequireAuth>
                    } />


                    <Route path="referrals/partner-analysis/:analysisType/:referralId" element={
                        <RequireAuth roles={[ADMIN, CREDIT_MANAGER, CREDIT_ANALYST]}>
                            <CreditLimitAnalysisForm />
                        </RequireAuth>
                    } />

                    <Route path="referrals/partner-analysis/:page/:pageSize/:field/:order/:filter?"
                        element={<RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}><ReferralPartnerAnalysisListPage /></RequireAuth>}>
                        <Route
                            path="agrolend-score/:referralId"
                            element={<ScoreAgrolendModal />}
                        />
                        <Route
                            path="biro-list/:referralId/:partnerId"
                            element={<BiroListModal />}
                        />
                        <Route
                            path="biro-variables/:referralId/:providerName"
                            element={<BiroVariablesModal />}
                        />
                        <Route
                            path="biro-document/:referralId/:providerName"
                            element={<BiroDocumentModal />}
                        />
                        <Route
                            path="referral-detail/:referralId"
                            element={<ReferralDetailModal />}
                        />
                    </Route>

                    <Route path="referrals/loan-order-analysis/:analysisType/:referralId" element={
                        <RequireAuth roles={[ADMIN, CREDIT_MANAGER, CREDIT_ANALYST]}>
                            <LoanOrderAnalysisForm />
                        </RequireAuth>
                    } />

                    <Route path="referrals/loan-order-analysis/rejected/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, CREDIT_MANAGER, CREDIT_ANALYST]}>
                            <ReferralLoanOrderRejectedListPage />
                        </RequireAuth>
                    } />

                    <Route path="farmers/view/:loanOrderId" element={
                        <RequireAuth roles={[ADMIN, CREDIT_MANAGER, CREDIT_ANALYST]}>
                            <FarmerDataViewPage />
                        </RequireAuth>
                    }>
                        <Route
                            path="biro-list/:referralId/:partnerId"
                            element={<BiroListModal />}
                        />
                        <Route
                            path="biro-variables/:referralId/:providerName"
                            element={<BiroVariablesModal />}
                        />
                        <Route
                            path="biro-document/:referralId/:providerName"
                            element={<BiroDocumentModal />}
                        />
                        <Route
                            path="referral-detail/:referralId"
                            element={<ReferralDetailModal />}
                        />
                    </Route>

                    <Route path="referrals/loan-order-analysis/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, CONTRACT_OPERATIONS_ANALYST]}>
                            <LoanOrderAnalysisListPage />
                        </RequireAuth>
                    } />

                    <Route path="referrals/farmer-analysis/:page/:pageSize/:field/:order/:filter?"
                        element={<RequireAuth roles={[ADMIN, CREDIT_MANAGER]}><FarmerOrderListPage /></RequireAuth>}>
                        <Route
                            path="agrolend-score/:referralId"
                            element={<ScoreAgrolendModal />}
                        />
                        <Route
                            path="biro-list/:referralId/:partnerId"
                            element={<BiroListModal />}
                        />
                        <Route
                            path="biro-variables/:referralId/:providerName"
                            element={<BiroVariablesModal />}
                        />
                        <Route
                            path="biro-document/:referralId/:providerName"
                            element={<BiroDocumentModal />}
                        />
                        <Route
                            path="referral-detail/:referralId"
                            element={<ReferralDetailModal />}
                        />
                    </Route>

                    <Route path="referrals/partner-analyzed/:page/:pageSize/:field/:order/:filter?"
                        element={<RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}><ReferralPartnerAnalyzedListPage /></RequireAuth>}>
                        <Route
                            path="agrolend-score/:referralId"
                            element={<ScoreAgrolendModal />}
                        />
                        <Route
                            path="biro-list/:referralId/:partnerId"
                            element={<BiroListModal />}
                        />
                        <Route
                            path="biro-variables/:referralId/:providerName"
                            element={<BiroVariablesModal />}
                        />
                        <Route
                            path="biro-document/:referralId/:providerName"
                            element={<BiroDocumentModal />}
                        />
                        <Route
                            path="referral-detail/:referralId"
                            element={<ReferralDetailModal />}
                        />
                    </Route>

                    <Route path="analysis/batch-analysis/:page/:pageSize/:field/:order/:filter?"
                        element={
                            <RequireAuth roles={[ADMIN, OPERATOR]}>
                                <BatchAnalysisListPage />
                            </RequireAuth>
                        } />

                    <Route path="analysis/batch-analysis/form" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <BatchAnalysisFormPage />
                        </RequireAuth>
                    } />

                    <Route path="analysis/batch-analysis/view/:id" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <BatchAnalysisView />
                        </RequireAuth>
                    } />

                    <Route path="cities" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <Suspense fallback={<Loading />}>
                                <Cities />
                            </Suspense>
                        </RequireAuth>
                    } />

                    <Route path="provinces" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <Suspense fallback={<Loading />}>
                                <Provinces />
                            </Suspense>
                        </RequireAuth>}
                    />

                    <Route path="commercial/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <CommercialPage />
                        </RequireAuth>
                    } />

                    <Route
                        path="commercial-association"
                        element={
                            <RequireAuth roles={[ADMIN, OPERATOR]}>
                                <CommercialFormPage />
                            </RequireAuth>
                        }
                    />

                    <Route path="referrals/reasons/:page/:pageSize/:field/:order/:filter?"
                        element={
                            <RequireAuth roles={[ADMIN, CREDIT_MANAGER]}>
                                <ReasonPageList />
                            </RequireAuth>
                        }
                    >
                        <Route
                            path="form"
                            element={<ReasonFormModal />}
                        />
                    </Route>

                    <Route path="referrals/configuration"
                        element={
                            <RequireAuth roles={[ADMIN, CREDIT_MANAGER]}>
                                <ReferralConfiguration />
                            </RequireAuth>
                        }
                    />

                    <Route path="referrals/linkwithreferral/:loanOrderUUID"
                        element={
                            <RequireAuth roles={[ADMIN, CREDIT_MANAGER]}>
                                <LinkUpReferralWithLoanOrderFormPage />
                            </RequireAuth>
                        }
                    />

                    <Route path="referrals/list-unlinked-order/:page/:pageSize/:field/:order/:filter?"
                        element={
                            <RequireAuth roles={[ADMIN, CREDIT_MANAGER]}>
                                <FarmerOrderUnlinkedListPage />
                            </RequireAuth>
                        }
                    />

                    <Route path="loan/form/:referralId" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <LoanFormPage />
                        </RequireAuth>
                    } />

                    <Route path="loan-order/farmer-list/:page/:pageSize/:field/:order/:filter?"
                        element={
                            <RequireAuth roles={[ADMIN, INDIVIDUAL_PERSON]}>
                                <FarmerPageList />
                            </RequireAuth>
                        }
                    />

                    <Route path="individual/individual-list/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <IndividualPageList />
                        </RequireAuth>
                    }>
                        <Route
                            path="profiles/:personId"
                            element={<SelectProfilesModal />}
                        />
                    </Route>

                    <Route path="person/individual/form" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <IndividualPageForm />
                        </RequireAuth>
                    }>
                    </Route>

                    <Route path="person/individual/edit/:personId" element={
                        <RequireAuth roles={[ADMIN, LEGAL]}>
                            <IndividualPageEdit />
                        </RequireAuth>
                    } />



                    <Route
                        path="feature-flags/referral/:page/:pageSize/:field/:order/:filter?"
                        element={
                            <RequireAuth roles={[ADMIN]}>
                                <FeatureFlagReferral />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="feature-flags/referral/view/:id"
                        element={
                            <RequireAuth roles={[ADMIN]}>
                                <FeatureFlagReferralView />
                            </RequireAuth>
                        }
                    />

                    <Route path="communication/notifications/:filter?"
                        element={
                            <RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                                <NotificationPageList />
                            </RequireAuth>
                        }
                    >
                        <Route path="messages/:notificationId" element={<div />} />
                        <Route path="messages/:notificationId/:messageId" element={<div />} />
                    </Route>

                    <Route path="communication/calendar/:scheduledType/:year/:month"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <NotificationCalendarPage />
                        </RequireAuth>}
                    />

                    <Route path="communication/batch-form/:scheduledType/:targetDate"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <BatchNotificationForm />
                        </RequireAuth>}
                    />

                    <Route path="communication/templates/:page/:pageSize/:field/:order/:filter?"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <TemplatesPageList />
                        </RequireAuth>}
                    />

                    <Route path="communication/template/:id"
                        element={<RequireAuth roles={[ADMIN, COLLECTION_ANALYST]}>
                            <TemplateViewPage />
                        </RequireAuth>}
                    />

                    <Route path="communication/configuration"
                        element={
                            <RequireAuth roles={[ADMIN]}>
                                <CommunicationConfiguration />
                            </RequireAuth>
                        }
                    />

                    <Route path="users" element={<RequireAuth roles={[ADMIN]}><UserPageList /></RequireAuth>}>
                        <Route path=":userId" element={<UserPageView />} />
                    </Route>

                    <Route
                        path="financial/disbursement-list"
                        element={
                            <RequireAuth roles={[ADMIN, FINANCIAL]}>
                                <ContractDisbursementList />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="financial/liquidations-list"
                        element={
                            <RequireAuth roles={[ADMIN, FINANCIAL]}>
                                <LiquidationsList />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="/financial/dimensa-lote-list"
                        element={
                            <RequireAuth roles={[ADMIN, FINANCIAL]}>
                                <DimensaLoteList />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="financial/biller"
                        element={
                            <RequireAuth roles={[ADMIN/*, FINANCIAL*/]}>
                                <BillerListBills />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="financial/biller/create"
                        element={
                            <RequireAuth roles={[ADMIN/*, FINANCIAL*/]}>
                                <BillerCreateBill />
                            </RequireAuth>
                        }
                    />

                    <Route
                        path="financial/biller/batch-create"
                        element={
                            <RequireAuth roles={[ADMIN/*, FINANCIAL*/]}>
                                <BillerBatchCreateBill />
                            </RequireAuth>
                        }
                    />

                    <Route path="/blocklist/:page/:pageSize/:field/:order/:filter?"
                        element={
                            <RequireAuth roles={[ADMIN, BLOCKLIST]}>
                                <BlockListPage />
                            </RequireAuth>
                        } />

                    <Route path="blocklist/file-input/form" element={
                        <RequireAuth roles={[ADMIN, BLOCKLIST]}>
                            <BlockListInputForm />
                        </RequireAuth>
                    } />
                    <Route path="blocklist/changed" element={
                        <RequireAuth roles={[ADMIN, BLOCKLIST]}>
                            <BlockListChanged />
                        </RequireAuth>
                    } />
                    <Route path="data-provider/batch-report/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <BatchReportPageList />
                        </RequireAuth>
                    } />
                    <Route path="data-provider/batch-report/form" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <BatchReportPageForm />
                        </RequireAuth>
                    } />
                    <Route path="data-provider/batch-report/view/:id/:page?/:pageSize?/:field?/:order?" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <BatchReportPageView />
                        </RequireAuth>
                    } />
                    <Route path="sicor/report/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <SicorReportPageList />
                        </RequireAuth>
                    } />
                    <Route path="sicor/document/:document/:page/:pageSize/:field/:order" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <SicorDocumentPageList />
                        </RequireAuth>
                    } />
                    <Route path="sicor/document/:document/:bacenId" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <SicorDocumentPageView />
                        </RequireAuth>
                    } />
                    <Route path="data-provider/report-type/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <ReportTypePageList />
                        </RequireAuth>
                    } />
                    <Route path="data-provider/report-type/view/:id" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <ReportTypePageView />
                        </RequireAuth>
                    } />
                    <Route path="data-provider/report-type/edit/:id" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <ReportTypePageForm />
                        </RequireAuth>
                    } />
                    <Route path="data-provider/annual-provider-reports/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, CREDIT_ANALYST, CREDIT_MANAGER]}>
                            <AnnualProviderReportPageList />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/parecer/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST]}>
                            <RecommendationEngineParecerView />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/parecer-view/:batchSk?" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST]}>
                            <RecommendationEngineParecerView />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/provider-documents/:batchId" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST]}>
                            <ProviderDocumentsGrid />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/rules/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST]}>
                            <RecommendationEngineRulesList />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/rule/view/:id" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST]}>
                            <RecommendationEnginePageView />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/recommendations/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST]}>
                            <RecommendationEngineRecommendationsList />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/recommendations/:id" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST]}>
                            <RecommendationEngineRecommendationView />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/rule/form" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST]}>
                            <RecommendationEnginePageForm />
                        </RequireAuth>
                    } />
                    <Route path="recommendation-engine/rule/edit/:id" element={
                        <RequireAuth roles={[ADMIN, MLP_ANALYST]}>
                            <RecommendationEnginePageForm />
                        </RequireAuth>
                    } />
                    <Route path="contracts/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <OperationsPage />
                        </RequireAuth>
                    } />
                    <Route path="contracts/new" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <OperationReceivablesAssignmentFormPage />
                        </RequireAuth>
                    } />
                    <Route path="operations/receivables-assignment/:id" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <ReceivablesAssignmentPage />
                        </RequireAuth>
                    } />
                    <Route path="contracts/loan/new" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <OperationLoanFormPage />
                        </RequireAuth>
                    } />
                    <Route path="operations/structured-operation/:id" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <StructuredOperationPage />
                        </RequireAuth>
                    } />
                    <Route path="operations/acknowledgement-debt/:id" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <AcknowledgementDebtPage />
                        </RequireAuth>
                    } />
                    <Route path="operations/loan/:id" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <OperationLoanFormPage />
                        </RequireAuth>
                    } />
                    <Route path="structuring/operations/:page/:pageSize" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <OperationPageList />
                        </RequireAuth>
                    } />
                    <Route path="structuring/operation" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <OperationPageForm />
                        </RequireAuth>
                    } />
                    <Route path="structuring/operation/view/:id" element={
                        <RequireAuth roles={[ADMIN, OPERATOR]}>
                            <OperationPageView />
                        </RequireAuth>
                    } />
                    <Route path="maintenance" element={<RequireAuth roles={[ADMIN]}><MaintenanceFormPage /></RequireAuth>} />
                    <Route path="ti/software-portfolio/:page/:pageSize/:field/:order/:filter?" element={
                        <RequireAuth roles={[ADMIN]}>
                            <SoftwarePortfolioPageList />
                        </RequireAuth>
                    } />
                    <Route path="/denied" element={<AccessDenied />} />
                    <Route path="/error" element={<InternalError />} />
                    <Route path="/network-error" element={<NetworkError />} />
                    <Route path="/logout" element={<Logout />} />
                </Route>
                <Route path="*" element={<NotFound />} />
                <Route path="/login" element={<Login />} />

            </Routes>
        </HashRouter >
    );
};
export default AppRoutes;